import {
    ON_IMPORTACAO_STATE,
    CLEAN_IMPORTACAO_STATE,
    ON_DOWNLOAD_COMPETENCIA_STATE,
    CLEAN_DOWNLOAD_COMPETENCIA_STATE
} from "../actionTypes";

const INITIAL_STATE = {
    importacao: {},
    downloadCompetencias: {}
};

// eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ON_IMPORTACAO_STATE:
            return {
                ...state,
                importacao: action.payload,
            };
        case CLEAN_IMPORTACAO_STATE:
            return {
                ...state,
                importacao: {},
            };       
        case ON_DOWNLOAD_COMPETENCIA_STATE:
            return {
                ...state,
                downloadCompetencias: action.payload,
            };
        case CLEAN_DOWNLOAD_COMPETENCIA_STATE:
            return {
                ...state,
                downloadCompetencias: {},
            };
        default:
            return state;
    }
};
